import React, { useEffect, useRef } from 'react';
import WaykeEvWeb from '@wayke-se/ev-web';
import '@wayke-se/ev-web/dist/index.css';
import { getMarketCode } from '../../utils/market';

interface EvCalculationProps {
  id: string;
  evCalculatorUrl: string;
}

const EvCalculation = ({ id, evCalculatorUrl }: EvCalculationProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref?.current?.id) {
      new WaykeEvWeb({
        url: evCalculatorUrl,
        id,
        rootId: ref.current.id,
        marketCode: getMarketCode(),
      });
    }
  }, []);

  return <div id="ev" ref={ref} />;
};

export default React.memo(EvCalculation);
